module.exports = __webpack_public_path__ + "img/RhenusMyDelivery_Tracking.1784fadd.jpg";